import { render, staticRenderFns } from "./CategoriesGrid.vue?vue&type=template&id=19b43bd8&scoped=true"
import script from "./CategoriesGrid.vue?vue&type=script&lang=js"
export * from "./CategoriesGrid.vue?vue&type=script&lang=js"
import style0 from "./CategoriesGrid.vue?vue&type=style&index=0&id=19b43bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b43bd8",
  null
  
)

export default component.exports